module.exports = __webpack_public_path__ + "static/img/material_2_1.900d3a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/papermaterial/material_2_1.jpg
// module id = FTT8
// module chunks = 1